
let intlMessages = {};
let _defaultLocale = 'en';

const getMessages = (locale = _defaultLocale) => {
  return Object.prototype.hasOwnProperty.call(intlMessages, locale)
    ? intlMessages[locale]
    : {};
};

const setMessages = (messages, defaultLocale = 'en') => {
  intlMessages = messages;
  _defaultLocale = defaultLocale;
};

export { getMessages, setMessages };
